import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { ISongDetailsInput, ISongInputWrapper } from "../SongForm/SongForm";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import MessageBox from "../../MessageBox/MessageBox";
import Button from "@mui/material/Button/Button";
import ButtonGroup from "@mui/material/ButtonGroup/ButtonGroup";
import TextField from "@mui/material/TextField/TextField";
import "./Melody.css";

interface props {
  songNumber: number;
  id: number;
  input: ISongInputWrapper;
  setInput: React.Dispatch<React.SetStateAction<ISongInputWrapper[]>>;
  syncInputData: () => void;
  delete: (
    input: ISongInputWrapper,
    id: number,
    songNumber: number,
    type: "verse" | "chorus" | "melody"
  ) => void;
  fetchData: (isMounted: boolean, controller: AbortController) => Promise<void>;
}

const Melody = (props: props) => {
  const axiosPrivate = useAxiosPrivate();

  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(true);
  const [newLyrics, setNewLyrics] = useState<string>(props.input.data.lyrics);

  const bandId = sessionStorage.getItem("editedBandId");
  const MELODY_URL = bandId ? `/admin/melodies/${bandId}` : "/melodies";

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<ISongDetailsInput>({
    defaultValues: {
      lyrics: "",
    },
  });

  useEffect(() => {
    setValue("lyrics", props.input.data.lyrics);
  }, [props.input]);

  useEffect(() => {
    props.setInput((prev) => {
      props.input.data.lyrics = newLyrics;
      return prev;
    });
  }, [newLyrics]);

  const onSubmit: SubmitHandler<ISongDetailsInput> = async (data) => {
    const { lyrics } = data;

    try {
      const response = await axiosPrivate.post(
        MELODY_URL,
        JSON.stringify({
          id: props.id,
          songNumber: props.songNumber,
          lyrics: lyrics,
        }),
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Response from API:", response);

      props.setInput((prev) => {
        props.input.data = data;
        return prev;
      });

      props.syncInputData();
      setResult(true);
      
      const isMounted = true;
      const controller = new AbortController();
      props.fetchData(isMounted, controller);
    } catch (error) {
      // Log the error in case the request fails
      console.error("Error in POST request:", error);
      setResult(false);
    }

    setOpen(true);
  };

  return (
    <form className="melody-container" onSubmit={handleSubmit(onSubmit)}>
      <div className="melody-content">
        <Controller
          name="lyrics"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <label>* Chwyty</label>
              <TextField
                {...field}
                error={newLyrics.length === 0 || newLyrics.trim() === ""}
                multiline
                rows={5}
                placeholder="* Wymagane"
                onChange={(e) => {
                  setNewLyrics(e.target.value);
                  field.onChange(e);
                }}
                value={newLyrics}
                helperText={errors.lyrics ? 'Wymagane!' : ''}
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: (theme) => theme.palette.error.main,
                    opacity: 1
                  }
                }}
              />
            </div>
          )}
        />
      </div>
      <ButtonGroup
        className="melody-buttons"
        variant="contained"
        size="large"
        orientation="vertical"
      >
        <Button
          size="large"
          onClick={() =>
            props.delete(props.input, props.id, props.songNumber, "melody")
          }
        >
          USUŃ MELODIĘ
        </Button>
      </ButtonGroup>
      <MessageBox open={open} setOpen={setOpen} error={!result} />
    </form>
  );
};

export default Melody;
